import { render, staticRenderFns } from "./LeftCol.vue?vue&type=template&id=ab037f4c&scoped=true"
import script from "./LeftCol.vue?vue&type=script&lang=js"
export * from "./LeftCol.vue?vue&type=script&lang=js"
import style0 from "./LeftCol.vue?vue&type=style&index=0&id=ab037f4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab037f4c",
  null
  
)

export default component.exports